export default "__VITE_ASSET__Cm89GNPl__"